import React from 'react';
import {
    Box,
    IconButton,
    SvgIcon,
    Theme,
    Typography,
    makeStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { X } from 'react-feather';
import { IHeader } from './types';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 15,
        paddingRigth: 15,
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: '3px 3px 0 0',
    },
    close: { marginRight: 10 },
}));

export const Header = ({ setOpen, ...props }: IHeader) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleClose = () => setOpen(false);

    return (
        <Box className={classes.root} {...props}>
            <Typography variant="h5">{t('Email.SendDocumentation')}</Typography>
            <Box flexGrow={1} />

            <IconButton onClick={handleClose} className={classes.close}>
                <SvgIcon fontSize="small">
                    <X color="white" />
                </SvgIcon>
            </IconButton>
        </Box>
    );
};
